export const LOAD_CAMPAIGNS = 'LOAD_CAMPAIGNS';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const REMOVE_CAMPAIGN = 'REMOVE_CAMPAIGN';

export const loadCampaigns = (campaigns) => ({
  type: LOAD_CAMPAIGNS,
  campaigns,
});

export const createCampaign = (campaign) => ({
  type: CREATE_CAMPAIGN,
  campaign,
});

export const updateCampaign = (campaign) => ({
  type: UPDATE_CAMPAIGN,
  campaign,
});

export const removeCampaign = (campaignId) => ({
  type: REMOVE_CAMPAIGN,
  campaignId,
});
